<!-- ===== METHOD HEADER ===== -->
<div class="method">

  <div class="mt-header">
    <div class="mt-breadcrumb">
      <span (click)="irr('home')">{{ t.breadcrumb_home }}</span>
      <span class="sep">→</span>
      <span class="current">{{ t.current }}</span>
    </div>

    <div class="mt-label">{{ t.label }}</div>
    <h1 class="mt-title" [innerHTML]="t.title"></h1>
    <p class="mt-lead">{{ t.lead }}</p>
    <p class="mt-intro">{{ t.intro }}</p>
  </div>

  <!-- ===== LO QUE NOS DEFINE ===== -->
  <div class="mt-section">
    <div class="mt-section-label">{{ t.define_title }}</div>
    <div class="mt-principles">
      <div class="mt-principle" *ngFor="let p of principles">
        <div class="mt-principle-bar"></div>
        <div>
          <h3 class="mt-principle-title">{{ p.title }}</h3>
          <p class="mt-principle-text">{{ p.text }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- ===== FASES DEL PROYECTO ===== -->
  <div class="mt-section">
    <div class="mt-section-label">{{ t.phases_title }}</div>
    <p class="mt-section-intro">{{ t.phases_intro }}</p>

    <div class="mt-timeline">
      <div class="mt-phase" *ngFor="let phase of phases; let last = last">
        <div class="mt-phase-rail">
          <div class="mt-phase-num">{{ phase.num }}</div>
          <div class="mt-phase-line" *ngIf="!last"></div>
        </div>

        <div class="mt-phase-body">
          <h3 class="mt-phase-name">{{ phase.name }}</h3>
          <p class="mt-phase-objective">{{ phase.objective }}</p>

          <div class="mt-activities" *ngIf="phase.activities">
            <div class="mt-activities-label">{{ t.activities_label }}</div>
            <ul>
              <li *ngFor="let a of phase.activities">{{ a }}</li>
            </ul>
          </div>

          <div class="mt-subsections" *ngIf="phase.subsections">
            <div class="mt-subsection" *ngFor="let s of phase.subsections">
              <h4>{{ s.title }}</h4>
              <p *ngIf="s.text">{{ s.text }}</p>
              <ul *ngIf="s.items">
                <li *ngFor="let it of s.items">{{ it }}</li>
              </ul>
            </div>
          </div>

          <div class="mt-callouts">
            <div class="mt-callout mt-callout-deliverable">
              <span class="mt-callout-label">{{ t.deliverable_label }}</span>
              <p>{{ phase.deliverable }}</p>
            </div>
            <div class="mt-callout mt-callout-close">
              <span class="mt-callout-label">{{ t.close_label }}</span>
              <p>{{ phase.closeCriteria }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ===== DOCUMENTOS DEL PROYECTO ===== -->
  <div class="mt-section">
    <div class="mt-section-label">{{ t.docs_title }}</div>
    <p class="mt-section-intro">{{ t.docs_intro }}</p>

    <div class="mt-table">
      <div class="mt-table-row mt-table-head">
        <span>{{ t.doc_col }}</span>
        <span>{{ t.phase_col }}</span>
        <span>{{ t.approved_col }}</span>
      </div>
      <div class="mt-table-row" *ngFor="let row of docs">
        <span class="mt-table-doc">{{ row.doc }}</span>
        <span class="mt-table-phase">{{ row.phase }}</span>
        <span class="mt-table-approved">{{ row.approvedBy }}</span>
      </div>
    </div>
  </div>

  <!-- ===== COMUNICACIÓN Y CADENCIA ===== -->
  <div class="mt-section">
    <div class="mt-section-label">{{ t.cadence_title }}</div>

    <div class="mt-cadence">
      <div class="mt-cadence-row" *ngFor="let row of cadence">
        <span class="mt-cadence-label">{{ row.label }}</span>
        <span class="mt-cadence-value">{{ row.value }}</span>
      </div>
    </div>
  </div>

  <!-- ===== CTA ===== -->
  <div class="mt-cta">
    <div class="mt-cta-text">
      <div class="mt-cta-label">{{ t.cta_label }}</div>
      <h2 class="mt-cta-title" [innerHTML]="t.cta_title"></h2>
    </div>
    <a href="https://wa.me/+543416902287" class="btn-primary">{{ t.cta_btn }}</a>
  </div>

</div>

<!-- ===== FOOTER ===== -->
<footer id="footer">
  <div class="footer-top">
    <div class="footer-brand">
      <div class="footer-brand-name">Patagonia Chain</div>
      <div class="footer-brand-sub">Rosario, Argentina — {{ t.footer_sub }}</div>
    </div>
    <div class="footer-links">
      <div class="footer-col">
        <div class="footer-col-title">{{ t.footer_nav }}</div>
        <ul>
          <li><a (click)="goHome('quienes')">{{ t.nav_quienes }}</a></li>
          <li><a (click)="goHome('servicios')">{{ t.nav_servicios }}</a></li>
          <li><a (click)="goHome('trabajos')">{{ t.nav_trabajos }}</a></li>
          <li><a (click)="goMethod()">{{ t.nav_metodologia }}</a></li>
          <li><a (click)="goHome('contacto')">{{ t.nav_contacto }}</a></li>
        </ul>
      </div>
      <div class="footer-col">
        <div class="footer-col-title">{{ t.footer_services }}</div>
        <ul>
          <li><a (click)="ir('robotizacion')">{{ lang === 'ESP' ? 'Robotización' : 'Robotics' }}</a></li>
          <li><a (click)="ir('ecommerce')">E-Commerce</a></li>
          <li><a (click)="ir('desarrollo-web')">Webs & Apps</a></li>
          <li><a (click)="ir('automatizacion')">{{ lang === 'ESP' ? 'Automatización' : 'Automation' }}</a></li>
          <li><a (click)="ir('inteligencia-artificial')">{{ lang === 'ESP' ? 'Inteligencia Artificial' : 'Artificial Intelligence' }}</a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <div class="footer-copy">© 2026 Patagonia Chain. {{ t.footer_rights }}</div>
    <div class="footer-sys" aria-hidden="true"><i></i>SYS ▸ ONLINE · PC-01 · 32.95°S 60.65°O</div>
    <div class="footer-social">
      <a href="https://www.instagram.com/patagoniachain/?hl=es" target="_blank" aria-label="Instagram">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <rect x="2" y="2" width="20" height="20" rx="5"/>
          <circle cx="12" cy="12" r="5"/>
          <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
        </svg>
      </a>
      <a href="https://linkedin.com/company/patagonia-chain" target="_blank" aria-label="LinkedIn">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <rect x="2" y="2" width="20" height="20" rx="4"/>
          <path d="M7 10v7M7 7v.01M12 17v-4a2 2 0 014 0v4M12 10v7"/>
        </svg>
      </a>
    </div>
  </div>
</footer>
